import {
  buildCleicLiveRedirectUrl,
  resolveCleicAppChannel as resolveCleicAppChannelFromConfig,
  resolveCleicLiveOnlyChannelsFlag,
} from '@cleic/config/channels';

export const CLEIC_APP_CHANNEL_QUERY_KEY = 'cleic_app_channel';

const APP_URLS_BY_CHANNEL = Object.freeze({
  ledger: Object.freeze({
    live: 'https://ledger.cleic.com',
    preview: 'https://preview-ledger.cleic.com',
    lab: 'https://lab-ledger.cleic.com',
  }),
  lens: Object.freeze({
    live: 'https://lens.cleic.com',
    preview: 'https://preview-lens.cleic.com',
    lab: 'https://lab-lens.cleic.com',
  }),
});

const CHANNEL_TITLE_PREFIX = Object.freeze({
  preview: 'Preview',
  lab: 'Lab',
});

export function isCleicLiveOnlyChannels() {
  return resolveCleicLiveOnlyChannelsFlag({
    rawLiveOnly: import.meta.env.VITE_CLEIC_LIVE_ONLY,
    prod: import.meta.env.PROD,
    vercelEnv:
      typeof __CLEIC_VERCEL_ENV__ !== 'undefined'
        ? __CLEIC_VERCEL_ENV__
        : import.meta.env.VERCEL_ENV,
  });
}

export function redirectPausedCleicChannelToLive() {
  if (typeof window === 'undefined') return false;

  const target = buildCleicLiveRedirectUrl(
    {
      hostname: window.location.hostname,
      pathname: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash,
    },
    { liveOnly: isCleicLiveOnlyChannels() },
  );

  if (!target || target === window.location.href) return false;
  window.location.replace(target);
  return true;
}

export function resolveCleicAppChannel() {
  if (typeof window === 'undefined') return null;

  return resolveCleicAppChannelFromConfig({
    hostname: window.location.hostname,
    explicitChannel: new URLSearchParams(window.location.search).get(CLEIC_APP_CHANNEL_QUERY_KEY),
    liveOnly: isCleicLiveOnlyChannels(),
  });
}

export function buildCleicDocumentTitle(appName, channel = resolveCleicAppChannel()) {
  const prefix = channel ? CHANNEL_TITLE_PREFIX[channel] : null;
  return prefix ? `${prefix} · ${appName}` : appName;
}

export function applyCleicDocumentTitle(appName) {
  const title = buildCleicDocumentTitle(appName);
  if (typeof document !== 'undefined') {
    document.title = title;
  }
  return title;
}

export function resolveCleicAppUrl(app, configuredUrl = '') {
  const channel = resolveCleicAppChannel();
  const channelUrl = channel ? APP_URLS_BY_CHANNEL[app]?.[channel] : null;
  return channelUrl || String(configuredUrl || APP_URLS_BY_CHANNEL[app]?.live || '').trim();
}

export function appendCleicAppChannel(targetUrl, channel = resolveCleicAppChannel()) {
  const trimmed = String(targetUrl ?? '').trim();
  if (!trimmed || !channel || channel === 'live') return trimmed;
  try {
    const url = new URL(trimmed);
    url.searchParams.set(CLEIC_APP_CHANNEL_QUERY_KEY, channel);
    return url.toString();
  } catch {
    return trimmed;
  }
}
